import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getCurrencyRequestRpc } from 'growth-monetization-service-types';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { getCurrencyStoreResponse } from '../currency/dataTransformer';
import { getEarlyRequestResult } from '../utils/earlyRequest';
import { transformToLegacyPurchaseMotionsShape } from './transformToLegacyPurchaseMotionsShape';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
const getLegacyCurrencyPromise = () => {
  return getEarlyRequestResult('currency', () => chirpClient.call(getCurrencyRequestRpc, {})).then(response => {
    const currencyStoreResponse = getCurrencyStoreResponse(response);
    return currencyStoreResponse;
  });
};
export const getInAppLegacyPurchaseMotionsResponse = locations => {
  const purchaseMotionsPromise = chirpClient.call(evaluateInAppRpc, {
    request: {
      locations,
      productApiNames: []
    }
  }).then(purchaseMotionsResponse => {
    return transformToLegacyPurchaseMotionsShape(locations, purchaseMotionsResponse);
  });
  return Promise.all([getLegacyCurrencyPromise(), purchaseMotionsPromise]).then(([currencyStoreResponse, purchaseMotionsResponse]) => {
    return {
      customerCurrencyCode: currencyStoreResponse.lockedCurrencyCode,
      defaultCurrency: currencyStoreResponse.defaultCurrencyCode,
      locations: purchaseMotionsResponse
    };
  });
};